import { createCompNode, TypedCompNodeFactory } from '@wix/thunderbolt-catharsis'
import { CssCompNodes } from '../types'

export const createCssCompNode: TypedCompNodeFactory<CssCompNodes> = (key, obj) => createCompNode(obj)
